import { render, staticRenderFns } from "./CheckColor.vue?vue&type=template&id=fe6d8d4c&scoped=true&lang=pug&"
import script from "./CheckColor.vue?vue&type=script&lang=js&"
export * from "./CheckColor.vue?vue&type=script&lang=js&"
import style0 from "./CheckColor.vue?vue&type=style&index=0&id=fe6d8d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6d8d4c",
  null
  
)

export default component.exports